import React from 'react';
import {
  core_apimessages_Money as Money,
} from '../../src/schemas/rql';
import CartApplePayButton from './CartApplePayButton';

interface Props {
  checkoutBundlingId: string;
  amountTotal: Money;
  adyenCheckoutPaymentMethodsConfig: string;
}

export function CartBundleFooterApplePayButton(props: Props) {
  return (
    <div className="checkout-cart-footer__button checkout-cart-footer__button--apple-pay">
      <CartApplePayButton
        variant="white-outlined"
        checkoutBundlingId={props.checkoutBundlingId}
        amountTotal={props.amountTotal}
        adyenCheckoutPaymentMethodsConfig={props.adyenCheckoutPaymentMethodsConfig}
        tracking={{
          displayStyle: 'default',
        }}
      />
    </div>
  );
}
